import { createContext } from "react";

const WidgetSettingsContext = createContext({});

export default WidgetSettingsContext;
